import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';

import StandardFooter from './StandardFooter/StandardFooter';
import ProductFooter from './ProductFooter/ProductFooter';
import LandingFooter from './LandingFooter/LandingFooter';

import ActionIcon from 'elements/ActionIcons/ActionIcon';

class Footer extends Component {
  static propTypes = {
    layout: PropTypes.string,
    copyright: PropTypes.string,
    iconText: PropTypes.string,
    mainLinks: PropTypes.arrayOf(PropTypes.object),
    sectionLinks: PropTypes.arrayOf(PropTypes.object),
    socialLinks: PropTypes.arrayOf(PropTypes.object),
    siteLinks: PropTypes.arrayOf(PropTypes.object),
    supportLink: PropTypes.string,
    withoutDivider: PropTypes.bool
  };

  static defaultProps = {
    iconText: 'Back to top'
  }

  state = {
    interval: null,
  }

  scrollStep = () => {
    if (window.pageYOffset === 0) {
      clearInterval(this.state.interval);
    }

    window.scroll(0, window.pageYOffset - (window.pageYOffset / 5));
  }

  scrollToTop = () => {
    const interval = setInterval(this.scrollStep.bind(this), 20);
    this.setState({ interval });
  }

  renderMainLinks = (styles, type) => {
    const { mainLinks } = this.props;

    if (type === 'plp' && mainLinks.length >= 3) {
      console.warn(`On screen size less than 1366px, total link's numbers is two. Current number: ${mainLinks.length}.`);
    }

    return mainLinks.map((link, key) => (
      <li className={styles.linkItem} key={`main-link-${key}`}>
        <a className={styles.link} href={link.href} target="_blank">
          {link.title}
        </a>
      </li>
    ));
  }

  renderSectionLinks = styles => {
    const { sectionLinks } = this.props;

    return sectionLinks.map((section, key) => (
      <div className={styles.linksSection} key={`link-section-${key}`}>
        <p className={styles.titleSection}>
          {section.title}
        </p>
        <ul className={styles.sectionLinksList}>
          {section.links.map((link, key) => (
            <li className={styles.sectionItem} key={`section-link-${key}`}>
              <a className={styles.sectionLink} href={link.href}>
                {link.title}
              </a>
            </li>
          ))}
        </ul>
      </div>
    ));
  }

  renderSocialLinks = styles => {
    const { socialLinks } = this.props;

    if (socialLinks.length > 4) {
      throw Error(`Social media Action Icons can vary between one and four. Current number: ${socialLinks.length}.`);
    }

    return socialLinks.map((link, key) => (
      <li className={styles.socialLink} key={`social-link-${key}`}>
          <ActionIcon
            icon={link.network}
            type={'social'}
            href={link.href}
            customClasses={styles.socialIcon}
          />
      </li>
    ));
  }

  renderSiteLinks = styles => {
    const { siteLinks } = this.props;

    return siteLinks.map((link, key) => (
      <li className={styles.websiteItem} key={`site-link-${key}`}>
        <a className={styles.websiteLink} href={link.href}>
          {link.title}
        </a>
      </li>
    ));
  }

  renderFooter = () => {
    const {
      layout,
      copyright,
      iconText,
      supportLink,
      withoutDivider
    } = this.props;

    let result = null;

    switch(layout) {
      default:
        result = (
          <StandardFooter
            supportLink={supportLink}
            toTopHandler={this.scrollToTop}
            copyright={copyright}
            withoutDivider={withoutDivider} />
        );
        break;
      case('plp'):
        result = (
          <ProductFooter
            renderMainLinks={this.renderMainLinks}
            renderSocialLinks={this.renderSocialLinks}
            toTopHandler={this.scrollToTop}
            copyright={copyright}/>
        );
        break;
      case('slp'):
        result = (
          <LandingFooter
            copyright={copyright}
            iconText={iconText}
            renderMainLinks={this.renderMainLinks}
            renderSocialLinks={this.renderSocialLinks}
            renderSectionLinks={this.renderSectionLinks}
            renderSiteLinks={this.renderSiteLinks}
            toTopHandler={this.scrollToTop}/>
        );
        break;
    }
    return result;
  }

  render () {
    return (
      <Fragment>
        {this.renderFooter()}
      </Fragment>
    );
  }
}

export default Footer;



// WEBPACK FOOTER //
// ./src/uis/components/Footer/Footer.js